export function selectLatestOmnibusTimestamp(state) {
  return state.findAndFilterData.latestOmnibusTimestamp;
}